import TextParagraph from 'components/SectionText/TextParagraph'
import useMedia from 'hooks/use-media'
import useSite from 'hooks/use-site'
import { useState } from 'react'
import styles from './OperationalHighlight.module.scss'

const OperationalHighlight = (props) => {
    const isSm = useMedia('(max-width: 768px)')
    const { locale } = useSite()
    const lang = locale.toLowerCase()
    const [items, setItems] = useState(props.items)
    const textHeader = {
        en: 'OPERATIONAL HIGHLIGHTS',
        th: 'OPERATIONAL HIGHLIGHTS'
    }
    const changeComponentIn = (i) => {
        items[i].show = true
        setItems([...items])
    }

    const changeComponentOut = (i) => {
        items[i].show = false
        setItems([...items])
    }
    const _render = () => {
        if (isSm) {
            return (
                <div className={styles.wrapperItemMobile}>
                    {items.map((item, i) => (
                        <div 
                            className={`${styles.item}`} 
                            // style={{backgroundImage: `url(${item.thumbnail})`}} 
                            key={`operational-hl-${i}`}>
                            <img className={styles.itemBg} src={item.thumbnail} />
                            <div className={styles.itemContentWrapper}>
                                <div className={styles.itemContent}>
                                    {item?.link ?
                                        <a href={item.link} target="_blank" title={item.content[lang].title}>
                                            <img src={item.icon} className={styles.icon} />
                                            <p className={styles.title}>{item.content[lang].title}</p>
                                            <p className={styles.description}>{item.content[lang].text_long}</p>
                                        </a> :
                                        <>
                                            <img src={item.icon} className={styles.icon} />
                                            <p className={styles.title}>{item.content[lang].title}</p>
                                            <p className={styles.description}>{item.content[lang].text_long}</p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )
        } else {
            return (
                <div className={styles.wrapperItem}>
                    {items.map((item, i) => (
                        <div className={`${styles.item} ${i % 2 ? styles.low : ''}`} key={`operational-hl-${i}`} onMouseOver={() => changeComponentIn(i)} onMouseLeave={() => changeComponentOut(i)}>
                            <img className={styles.itemThumbnail} src={item.thumbnail} />
                            <div className={styles.itemContentWrapper}>
                                <div className={`${styles.itemContent} ${item?.show ? styles.show : ''}`}>
                                    {item?.link ?
                                        <a href={item.link} target="_blank" title={item.content[lang].title}>
                                            <img src={item.icon} className={styles.icon} />
                                            <div>
                                                <p className={styles.title}>{item.content[lang].title}</p>
                                                <p className={styles.description}>{item.content[lang].text_long}</p>
                                            </div>
                                        </a> :
                                        <>
                                            <img src={item.icon} className={styles.icon} />
                                            <div>
                                                <p className={styles.title}>{item.content[lang].title}</p>
                                                <p className={styles.description}>{item.content[lang].text_long}</p>
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className={`${styles.itemContentIcon} ${item?.show ? styles.hide : ''}`}>
                                    <img src={item.icon} className={styles.icon} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )
        }
    }
    return (
        <div className={styles.wrapper}>
            <TextParagraph className={styles.textHeader}>{textHeader[lang]}</TextParagraph>
            {_render()}
        </div>
    )
}

export default OperationalHighlight